export const ModelPortfoliosStoreConfig = {
	modelPortfolios: { name: 'modelPortfolios', storeAsList: true },
	modelPortfolioDetailsList: { name: 'modelPortfolioDetailsList', storeAsList: true },
	selectedModelPortfolioIds: { name: 'selectedModelPortfolioIds', storeAsList: false }
};

export const ModelPortfoliosStoreFeatureName = 'modelPortfolios';
